// extracted by mini-css-extract-plugin
export default {"dialog":"Privacy&Personal_dialog__nZ7yo","content":"Privacy&Personal_content__lG3Wo","subtitle":"Privacy&Personal_subtitle__alOC2","list":"Privacy&Personal_list__tmDpj"};